import { ChevronDownIcon } from '../../icons/icons';
import GrayButton from '../GrayButton';
import { ReactComponent as FilterIcon } from 'static/icons/filter.svg';

const FilterButton = ({ filters, toggleFieldDropdown }) => {
  const isDefaultState = Object.entries(filters)?.length <= 1;
  const buttonClasses = !isDefaultState && 'bg-transparent border-0 !px-1  ';

  const renderContent = () => {
    if (isDefaultState) {
      return (
        <>
          <FilterIcon className="!h-5 !w-5 group-hover:text-secondary" />
          <span>Filter</span>
          <ChevronDownIcon className="inline-block ml-2" />
        </>
      );
    }

    return <FilterIcon className="!h-5 !w-5 group-hover:text-secondary" />;
  };

  return (
    <GrayButton
      type="button"
      onClick={toggleFieldDropdown}
      icon={renderContent()}
      className={buttonClasses}
    />
  );
};

export default FilterButton;
